import Vue from 'vue'
import store from '../store'
import Router from 'vue-router'
import Login from '../views/Login'
import Home from '../views/Home'
import changePwd from '../views/changePwd'
import admin from '../views/admin'
import appInfo from '../views/appInfo'
// import prompt from '../views/prompt'
import notice from '../views/notice'
import chatMessage from '../views/chatMessage'
import messageList from '../views/chatMessage/messageList'
import messageDetail from '../views/chatMessage/messageDetail'
import aiModelConfig from '../views/aiModelConfig/index.vue'
import noticeForm from '../views/notice/noticeForm'
import { Message } from 'element-ui'
Vue.use(Router)

const routes = [
  { path: '/l', redirect: '/login' },
  { path: '/login', component: Login },
  {
    path: '/', redirect: '/sys/admin' ,
    component: Home,
    children: [
      { path: '/sys/admin', component: admin },
      { path: '/sys/changePwd', component: changePwd },
      { path: '/sys/appInfo', component: appInfo },
      // { path: '/sys/prompt', component: prompt },
      { path: '/sys/notice', component: notice },
      { path: '/sys/noticeForm', component: noticeForm },
      { path: '/sys/chatMessage', component: chatMessage },
      { path: '/sys/messageList', component: messageList },
      { path: '/sys/messageDetail', component: messageDetail },
      { path: '/sys/aiModelConfig', component: aiModelConfig },
    ],
  },
]
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err)
}
const router = new Router({
  // mode:'history',防止路径出现'#'
  routes,
})

function asyncRoutesHandler(routes) {
  return routes?.map((r) => {
    if (r.type === 'Category') {
      r.path = r.linkUrl
      r.component = Home
    } else {
      const filePath = r.cssName
      r.path = r.linkUrl
      r.component = () => import(`@/views/${filePath}`)
    }
    if (r.children.length != 0) {
      r.children = asyncRoutesHandler(r.children)
    }
    return r
  })
}

export default router
